import { Box, Table, Text } from '@mantine/core';
import { type ReactElement } from 'react';

interface KeyValueTableProps {
    entries: [string, unknown][];
    keyWidth?: string;
}

function formatValue(value: unknown): string {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'string') return value;
    return JSON.stringify(value);
}

/**
 * Bordered two-column table of key → value for displaying a record of raw
 * attributes. Non-string values are JSON-stringified; null/undefined show `—`.
 */
export default function KeyValueTable({ entries, keyWidth = '40%' }: KeyValueTableProps): ReactElement {
    return (
        <Box style={{ border: '1px solid var(--bm-color-border)', borderRadius: 'var(--bm-radius)', overflow: 'hidden' }}>
            <Table verticalSpacing={0} horizontalSpacing={0}>
                <Table.Tbody>
                    {entries.map(([key, value]) => (
                        <Table.Tr key={key} style={{ borderBottom: '1px solid var(--bm-color-border-subtle)' }}>
                            <Table.Td style={{ padding: '8px 16px', width: keyWidth }}>
                                <Text size="xs" c="dimmed" ff="monospace">
                                    {key}
                                </Text>
                            </Table.Td>
                            <Table.Td style={{ padding: '8px 16px' }}>
                                <Text size="xs" style={{ wordBreak: 'break-word' }}>
                                    {formatValue(value)}
                                </Text>
                            </Table.Td>
                        </Table.Tr>
                    ))}
                </Table.Tbody>
            </Table>
        </Box>
    );
}
